import Contact from '@repo/utils/models/Contact';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentView, setActiveContact } from '@repo/redux/actions/ui';
import { useEffect } from 'react';

export const useAppContactSelecting = ({
  contact,
  source,
  additionalDeps = [],
}: {
  contact: Contact | null;
  source: string;
  additionalDeps?: Array<any>;
}) => {
  const dispatch = useDispatch();
  const currentView = useSelector(selectCurrentView);
  const isOnContactView = currentView && currentView.startsWith('Contact');

  useEffect(() => {
    let nextActiveContact = null;
    if (!['paddingRow', 'sectionHeader'].includes(contact?.id)) {
      nextActiveContact = contact;
    }
    dispatch(setActiveContact(nextActiveContact || null, source));
  }, [contact, isOnContactView].concat(additionalDeps));
};
